import { render, staticRenderFns } from "./Pots.vue?vue&type=template&id=f95c9f8c&"
import script from "./Pots.vue?vue&type=script&lang=js&"
export * from "./Pots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports